import "babel-polyfill";

window._ = require('lodash');

window.$ = window.jQuery = require('jquery');

window.Vue = require('vue');

window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

window.Cookies = require('js-cookie');

import EventHandler from './core/EventHandler';
window.EventHandler = new EventHandler;

import ViewPort from './core/ViewPort';
window.ViewPort = new ViewPort;


// WEBPACK FOOTER //
// ./resources/js/src/bootstrap.js